export default "__VITE_ASSET__boliQLo8__"